import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=0ea4e072&scoped=true&"
import script from "./BackHeader.vue?vue&type=script&lang=js&"
export * from "./BackHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackHeader.vue?vue&type=style&index=0&id=0ea4e072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4e072",
  null
  
)

export default component.exports